import { SlackConnectionStatus } from '../../../../../types';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

type SlackConnectionCardProps = Readonly<{
  connection?: SlackConnectionStatus;
  isLoading?: boolean;
}>;

export default function SlackConnectionCard({
  connection,
}: SlackConnectionCardProps) {
  const workspace = [connection?.teamName, connection?.teamId]
    .filter(Boolean)
    .join(' ') || <Skeleton width={200} height={24} />;
  const user = [connection?.userName, connection?.userId]
    .filter(Boolean)
    .join(' ') || <Skeleton width={200} height={24} />;

  return (
    <Paper
      variant="outlined"
      sx={{
        mt: '24px',
        width: '100%',
        minHeight: 'calc(100% - 24px)',
        boxSizing: 'border-box',
        p: '12px',
        bgcolor: (theme) => theme.palette.semantic.surface.bg2,
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          rowGap: 1.5,
          columnGap: 2.5,
          alignItems: 'start',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          Workspace
        </Typography>
        <Typography variant="body2">{workspace}</Typography>

        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          User
        </Typography>
        <Typography variant="body2">{user}</Typography>

        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          Token Scopes
        </Typography>
        {connection?.scopes && connection.scopes.length > 0 ? (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
            {connection.scopes.map((scope) => (
              <Chip
                key={scope}
                label={scope}
                size="small"
                variant="outlined"
                sx={{ bgcolor: (theme) => theme.palette.semantic.tags.default }}
              />
            ))}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', gap: 0.75 }}>
            <Skeleton width={80} height={24} />
            <Skeleton width={80} height={24} />
            <Skeleton width={70} height={24} />
          </Box>
        )}
      </Box>
    </Paper>
  );
}
